export default __webpack_public_path__ + "static/media/Garmin_Connect_app_1024x1024-02.912cf11a.png";